import { connect } from 'react-redux'

import NumbersAnimationProvider from 'app/components/AnimationProviders/NumbersAnimationProvider'
import { getIdentityProgressAllStreakCurrent } from 'store/entities/identity/selectors'
import StreakDetails from './StreakDetails'

const mapStateToProps = state => ({
  animate: {
    streakCurrent: {
      from: 0,
      to: getIdentityProgressAllStreakCurrent(state),
      duration: 1200,
      easing: 'in-sine',
      int: true,
    },
  },
})

export default connect(mapStateToProps)(NumbersAnimationProvider(StreakDetails))
